import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell, faSignOutAlt, faTasks, faUser, faCheckDouble
} from "@fortawesome/free-solid-svg-icons";
import { faUserCircle } from "@fortawesome/free-regular-svg-icons";
import { Nav, Navbar, Dropdown, Container, ListGroup, Badge, Button } from '@themesberg/react-bootstrap';
import { useHistory, Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export default (props) => {
  const history = useHistory();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");

  const [notifications, setNotifications] = useState([]);
  const [userName, setUserName] = useState("Utilizador");
  const [currentUserId, setCurrentUserId] = useState(null);
  const [isStaff, setIsStaff] = useState(false);

  const authHeaders = () => ({
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json"
  });

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);

        // 1. Extrair Nome
        const name = decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"] || "Utilizador";
        setUserName(name);

        // 2. Extrair ID do Utilizador (Conforme o seu token, a chave é "id")
        const uid = decoded["id"] || decoded["sub"];
        setCurrentUserId(uid);

        // 3. Verificar Role
        const role = decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
        const staffRoles = ["admin", "treinador", "tesoureiro"];
        setIsStaff(staffRoles.includes(role?.toLowerCase()));

        fetchNotifications();
      } catch (e) { console.error("Erro ao ler token:", e); }
    }
  }, [token]);

  const fetchNotifications = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/Mensagens`, { headers: authHeaders() });
      if (res.ok) {
        const data = await res.json();
        setNotifications(Array.isArray(data) ? data : []);
      }
    } catch (err) { console.error(err); }
  };

  const markAsRead = async (id) => {
    try {
      const res = await fetch(`${API_BASE_URL}/Mensagens/${id}/ler`, {
        method: "PATCH",
        headers: authHeaders()
      });
      if (res.ok) {
        setNotifications(notifications.map(n => n.id === id ? { ...n, isLida: true } : n));
      }
    } catch (err) { console.error(err); }
  };

  const markAllAsRead = async (lista) => {
    const unreadIds = lista.filter(n => !n.isLida).map(n => n.id);
    if (unreadIds.length === 0) return;

    await Promise.all(unreadIds.map(id =>
        fetch(`${API_BASE_URL}/Mensagens/${id}/ler`, { method: "PATCH", headers: authHeaders() })
    ));
    fetchNotifications();
  };

  const handleLogout = (e) => {
    e.preventDefault();
    if (window.confirm("Tem a certeza que quer sair?")) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/";
    }
  };

  // --- FILTRAGEM REFINADA ---

  // 1. Alertas de Staff: Apenas os 2 tipos solicitados e apenas se o utilizadorId coincidir
  const staffNotifs = isStaff
      ? notifications.filter(n =>
          (n.tipo === "NotificacaoConfirmacaoEvento" || n.tipo === "NotificacaoNovoPraticante") &&
          String(n.utilizadorId) === String(currentUserId)
      ).sort((a, b) => new Date(b.dataEnvio) - new Date(a.dataEnvio))
      : [];

  const unreadStaffCount = staffNotifs.filter(n => !n.isLida).length;

  // 2. Notificações de Utilizador: Tudo o que não for os tipos de Staff (e apenas para não-staff)
  const userNotifsFull = !isStaff
      ? notifications.filter(n => {
        const isStaffType = n.tipo === "NotificacaoConfirmacaoEvento" || n.tipo === "NotificacaoNovoPraticante";
        return !isStaffType;
      }).sort((a, b) => {
        if (a.isLida === b.isLida) return new Date(b.dataEnvio) - new Date(a.dataEnvio);
        return a.isLida ? 1 : -1;
      })
      : [];

  const unreadUserCount = userNotifsFull.filter(n => !n.isLida).length;
  const userNotifsDisplay = userNotifsFull.slice(0, 5);

  const staffIconColor = "#f59e0b";
  const staffToggleStyle = unreadStaffCount > 0 ? {
    color: staffIconColor,
    filter: `drop-shadow(0 0 5px ${staffIconColor})`,
    animation: "pulse 1.5s infinite"
  } : {
    color: staffIconColor,
    opacity: 0.8
  };

  return (
      <>
        <style>{`
          @keyframes bell-shake {
            0% { transform: rotate(0); }
            10% { transform: rotate(15deg); }
            20% { transform: rotate(-15deg); }
            30% { transform: rotate(10deg); }
            40% { transform: rotate(-10deg); }
            50% { transform: rotate(0); }
          }
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.1); }
            100% { transform: scale(1); }
          }
          .bell-shake-anim { animation: bell-shake 2s infinite; }
          .unread-badge-custom {
            position: absolute; top: 2px; right: 2px; background-color: #fa5252; color: white;
            font-size: 0.65rem; font-weight: bold; min-width: 18px; height: 18px;
            border-radius: 50%; border: 2px solid white; display: flex; align-items: center;
            justify-content: center; z-index: 10;
          }

          /* Mobile: dropdown de notificações fixo no ecrã */
          @media (max-width: 767px) {
            .notifications-dropdown {
              position: fixed !important;
              top: 60px !important;
              left: 8px !important;
              right: 8px !important;
              width: auto !important;
              min-width: unset !important;
              max-width: unset !important;
              transform: none !important;
              z-index: 1050;
            }
          }
        `}</style>

        <Navbar variant="dark" expanded className="ps-0 pe-2 pb-0">
          <Container fluid className="px-0">
            <div className="d-flex justify-content-between w-100">
              <div />
              <Nav className="align-items-center">

                {/* SINO DE UTILIZADOR */}
                {!isStaff && (
                    <Dropdown as={Nav.Item}>
                      <Dropdown.Toggle as={Nav.Link} className="icon-notifications me-lg-3 p-0" style={{ border: 'none', background: 'none' }}>
                      <span className="icon icon-sm d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', position: 'relative' }}>
                        <FontAwesomeIcon
                            icon={faBell}
                            style={{ fontSize: '1.25rem', color: unreadUserCount > 0 ? "#262752" : "#adb5bd" }}
                            className={unreadUserCount > 0 ? "bell-shake-anim" : ""}
                        />
                        {unreadUserCount > 0 && <span className="unread-badge-custom">{unreadUserCount > 9 ? "9+" : unreadUserCount}</span>}
                      </span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dashboard-dropdown notifications-dropdown dropdown-menu-lg dropdown-menu-center mt-2 py-0 shadow-lg">
                        <ListGroup className="list-group-flush">
                          <div className="text-center text-primary fw-bold border-bottom border-light py-3">Comunicações</div>
                          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            {userNotifsDisplay.length > 0 ? (
                                userNotifsDisplay.map(n => (
                                    <ListGroup.Item key={n.id} action className={`border-bottom border-light ${n.isLida ? "" : "bg-soft-light"}`} onClick={() => markAsRead(n.id)}>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <h4 className="h6 mb-0 text-small">{n.tipo}{!n.isLida && <Badge bg="danger" className="ms-2" style={{fontSize: '0.6rem'}}>NOVA</Badge>}</h4>
                                        <small className="text-muted">{new Date(n.dataEnvio).toLocaleDateString()}</small>
                                      </div>
                                      <p className={`font-small mt-1 mb-0 ${n.isLida ? "text-muted" : "text-dark fw-bold"}`}>{n.conteudo}</p>
                                    </ListGroup.Item>
                                ))
                            ) : <div className="text-center p-4 text-muted font-small">Sem comunicações</div>}
                          </div>
                          <div className="d-flex border-top border-light">
                            <Button variant="link" className="text-primary fw-bold w-50 border-end py-3 text-decoration-none" onClick={() => history.push("/connect/mensagens/user")}>Histórico</Button>
                            <Button variant="link" className="text-success fw-bold w-50 py-3 text-decoration-none" disabled={unreadUserCount === 0} onClick={() => markAllAsRead(userNotifsFull)}>
                              <FontAwesomeIcon icon={faCheckDouble} className="me-1" /> Ler Todas
                            </Button>
                          </div>
                        </ListGroup>
                      </Dropdown.Menu>
                    </Dropdown>
                )}

                {/* ÍCONE STAFF */}
                {isStaff && (
                    <Dropdown as={Nav.Item}>
                      <Dropdown.Toggle as={Nav.Link} className="icon-notifications me-lg-3 p-0" style={{ border: 'none', background: 'none' }}>
                        <span className="icon icon-sm d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', position: 'relative' }}>
                          <FontAwesomeIcon icon={faTasks} style={staffToggleStyle} />
                          {unreadStaffCount > 0 && <span className="badge rounded-circle bg-warning" style={{ position: 'absolute', top: '5px', right: '5px', width: '10px', height: '10px', border: '2px solid white' }} />}
                        </span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dashboard-dropdown notifications-dropdown dropdown-menu-lg dropdown-menu-center mt-2 py-0 shadow-lg">
                        <ListGroup className="list-group-flush">
                          <div className="text-center text-warning fw-bold border-bottom border-light py-3">Painel de Gestão</div>
                          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            {staffNotifs.length > 0 ? staffNotifs.slice(0, 10).map(n => (
                                <ListGroup.Item key={n.id} action className={`border-bottom border-light ${n.isLida ? "" : "bg-soft-warning"}`} onClick={() => markAsRead(n.id)}>
                                  <div className="d-flex justify-content-between">
                                    <h4 className="h6 mb-0 text-small">
                                      {n.tipo === "NotificacaoNovoPraticante" ? "Novo Praticante" : "Presença Evento"}
                                    </h4>
                                    <small className="text-muted">{new Date(n.dataEnvio).toLocaleDateString()}</small>
                                  </div>
                                  <p className={`font-small mt-1 mb-0 ${n.isLida ? "text-muted" : "text-dark fw-bold"}`}>{n.conteudo}</p>
                                </ListGroup.Item>
                            )) : <div className="text-center p-3 text-muted font-small">Sem tarefas pendentes</div>}
                          </div>
                          <div className="d-flex border-top border-light">
                            <Button variant="link" className="text-warning fw-bold w-50 border-end py-3 text-decoration-none" onClick={() => history.push("/connect/mensagens/admin")}>Alertas</Button>
                            <Button variant="link" className="text-success fw-bold w-50 py-3 text-decoration-none" onClick={() => markAllAsRead(staffNotifs)}>Ler Tudo</Button>
                          </div>
                        </ListGroup>
                      </Dropdown.Menu>
                    </Dropdown>
                )}

                {/* PERFIL */}
                <Dropdown as={Nav.Item}>
                  <Dropdown.Toggle as={Nav.Link} className="pt-1 px-0">
                    <div className="media d-flex align-items-center">
                      <div className="icon-shape icon-sm bg-soft-primary text-primary rounded-circle me-2">
                        <FontAwesomeIcon icon={faUserCircle} />
                      </div>
                      <span className="mb-0 font-small fw-bold text-dark">{userName}</span>
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="user-dropdown dropdown-menu-right mt-2 shadow-sm">
                    <Dropdown.Item as={Link} to="/connect/perfil"><FontAwesomeIcon icon={faUser} className="me-2" /> Meu Perfil</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={handleLogout} className="text-danger fw-bold"><FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Sair</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

              </Nav>
            </div>
          </Container>
        </Navbar>
      </>
  );
};